var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60177 10.3824C7.8291 10.5845 8.17167 10.5845 8.399 10.3824L13.7346 5.63964C13.8998 5.49288 14.1526 5.50775 14.2994 5.67286C14.4461 5.83797 14.4312 6.0908 14.2661 6.23757L8.9305 10.9804C8.40005 11.4519 7.60072 11.4519 7.07028 10.9804L1.73464 6.23757C1.56953 6.0908 1.55466 5.83797 1.70142 5.67286C1.84819 5.50775 2.10102 5.49288 2.26613 5.63964L7.60177 10.3824Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionArrow);
export default __webpack_public_path__ + "static/media/accordionArrow.34762c795faca8e8a27c8d502aa796e7.svg";
export { ForwardRef as ReactComponent };